import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import { useCallback, useMemo } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { WORKSTREAM_BANNER_VISIBLE_STORAGE_KEY } from '@/modules/workstream/lib/constants';
import type { HTMLMotionProps } from 'motion/react';
function useWorkstreamBanner() {
  const $ = _c(16);
  const {
    slug: networkSlug
  } = useParams();
  const bannerVisibleStorageKey = networkSlug ? `${networkSlug}-${WORKSTREAM_BANNER_VISIBLE_STORAGE_KEY}` : WORKSTREAM_BANNER_VISIBLE_STORAGE_KEY;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      deserializer(value) {
        return value !== "false";
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [isVisible, setIsVisible] = useLocalStorage(bannerVisibleStorageKey, true, t0);
  const isNetworkBanner = !!networkSlug;
  let t1;
  if ($[1] !== setIsVisible) {
    t1 = () => {
      setIsVisible(false);
    };
    $[1] = setIsVisible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleHide = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      height: 0,
      marginBottom: 0
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isVisible ? 1 : 0;
  const t4 = isVisible ? "auto" : 0;
  const t5 = isVisible ? "calc(var(--spacing) * 8)" : 0;
  let t6;
  if ($[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = {
      opacity: t3,
      height: t4,
      marginBottom: t5
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = {
      initial: t2,
      animate: t6,
      transition: t7
    };
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const animationProps = t8;
  let t9;
  if ($[11] !== animationProps || $[12] !== handleHide || $[13] !== isNetworkBanner || $[14] !== isVisible) {
    t9 = {
      isVisible,
      isNetworkBanner,
      handleHide,
      animationProps
    };
    $[11] = animationProps;
    $[12] = handleHide;
    $[13] = isNetworkBanner;
    $[14] = isVisible;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
export { useWorkstreamBanner };